var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3601 3.43513L16.875 1.92043L16.0796 1.125L14.5649 2.63976L13.95 2.025C13.8485 1.91831 13.7263 1.83337 13.5909 1.77533C13.4555 1.71729 13.3098 1.68736 13.1625 1.68736C13.0152 1.68736 12.8695 1.71729 12.7341 1.77533C12.5987 1.83337 12.4765 1.91831 12.375 2.025L2.25 12.15L2.25 15.75H5.85L15.975 5.625C16.0817 5.52345 16.1666 5.40128 16.2246 5.26591C16.2827 5.13054 16.3126 4.98479 16.3126 4.8375C16.3126 4.69021 16.2827 4.54446 16.2246 4.40909C16.1666 4.27372 16.0817 4.15155 15.975 4.05L15.3601 3.43513ZM5.4 14.625H3.375L3.375 12.6L13.1625 2.8125L15.1875 4.8375L5.4 14.625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32959 2.25001L5.06251 6.51708L5.85793 7.3125L10.125 3.04542L9.32959 2.25001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenIcon);
export default __webpack_public_path__ + "static/media/edit-pen-icon.e69aebafefbe9b5e5fbd71baa8a15499.svg";
export { ForwardRef as ReactComponent };